import React, { useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom';
import { Card, Col, Row, Button } from 'react-bootstrap';
import Section from '../../common/Section';
import bgShape from '../../../assets/img/illustrations/bg-shape.png';
import shape1 from '../../../assets/img/illustrations/shape-1.png';
import Alice from '../../../assets/img/login-img/alice.webp';
import AngelBooking from '../../../assets/img/login-img/angel_booking.webp';
import paisa from '../../../assets/img/login-img/5paisa.webp';
import firstock from '../../../assets/img/login-img/firstock.png';
import BrokerLoginModal from '../../authentication/modal/brokerLogin';
import { logoutUser } from "../../../api/authentication";
import { removeUser } from "../../../redux/actions/user";
import {deleteCookieCredentials} from '../../../util/helper';
import { makeStyles } from "@material-ui/styles";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {isMobile} from 'react-device-detect';
import { Collapse } from 'antd';
import logo from '../../../assets/img/favicons/android-chrome-512x512.png';
import './BrokerCard.css';
import AppContext from "context/Context";

const useStyles = makeStyles(() => ({
  logout: {
    position:"absolute",
    right:"8px",
    top:"3px",
    cursor: "pointer"
  },
  bottomText: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    margin: "auto",
    borderRadius: "8px",
    cursor: "pointer"
  },
  h5: {
    fontSize:'14px',
    fontWeight:'500',
    cursor: "pointer",
    color: "#000"
  },
  p: {
    fontSize:'15px',
    margin:"0",
    cursor: "pointer"
  },
  textDiv: { 
    marginLeft:"15px",
    cursor: "pointer",
    marginRight: "15px",
    textAlign:"left"
  },
  collepsDiv: {
    width:"90%",
    margin:"auto"
  },
  backButton: {
    cursor:"pointer",
    marginTop: "13px",
    marginBottom: "13px",
    marginLeft: "7px"
  },
  boxSize :{
    width: "90%", 
    height: "100px", 
    color :"#000", 
    fontWeight:"600", 
    fontSize: "14px", 
    padding: "4px"
  },
  h5Bold: (isDark) => ({
    fontWeight: "600",
    color: isDark ? "#CBD5E1" : "#4B5563",
    fontSize: "16px"
  })
}));

const { Panel } = Collapse;
const DontBrokerAccount = ({ embedded = false }) => {
  const [show, setShow] = useState(false);
  const [defaultActiveKey, setdefaultActiveKey] = useState(1);
  const [isSafe, setSafe] = useState(false);
 
  const [loginType, setloginType] = useState(false);
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const { config: { isDark } } = useContext(AppContext);
  
  const classes = useStyles(isDark);

  const showLoginModal = (type) => {
    setShow(true);
    setloginType(type)
  };

  async function logout() {
    const res = await logoutUser(user);
    const {code} = res;

    if (code === 200) {
      deleteCookieCredentials();
      dispatch(removeUser()); 
      navigate("/authentication/login");
    }
  }
  
  const onTabChange = (key) => {
    setdefaultActiveKey(key);
  };
  
  const OpenIsSafe = (isSafe) => {
      setSafe(!isSafe)
  }
  
  if (embedded) {
    return (
      <div>
        <div className={classes.backButton}>
          <Link to={{ pathname: '/broker-login' }}>
            <FontAwesomeIcon icon={'arrow-left'} /> Back
          </Link>
        </div>
        <div style={{marginTop: "4px"}} className="d-flex justify-content-center align-items-center">
          <img className="text-center" src={logo} alt="" width={28} style={{marginRight:"5px"}} />
          <h6 className="text-center" style={{color:"#2c87f2", fontWeight: 800, fontSize: "18px", marginBottom: 0}}>FNOTrader</h6>
        </div>
        <div style={{textAlign:"center",color:"#fff",paddingTop:"8px",paddingBottom:"8px"}}>
          <h6 className={classes.h5Bold}>Open a broker account of your choice.</h6>
        </div>
        <Row className="g-1 mb-1 broker-list-l">
          <Col md={4} xs={6}>
            <a className='text-white' href="https://www.5paisa.com/demat-account?ReferralCode=57003172&ReturnUrl=invest-open-account" target="_blank" rel="noopener noreferrer">
              <button className="broker-card" title="Open 5Paisa account" aria-label="Open 5Paisa account">
                <div className="broker-card-content">
                  <img className="broker-card-logo" src={paisa} alt="" width="24" />
                  <div className="broker-card-text">
                    <span className="broker-card-name">5Paisa</span>
                  </div>
                </div>
              </button>
            </a>
          </Col>
          <Col md={4} xs={6}>
            <a className='text-white' href="https://signup.firstock.in/?p=FNO99" target="_blank" rel="noopener noreferrer">
              <button className="broker-card" title="Open Firstock account" aria-label="Open Firstock account">
                <div className="broker-card-content">
                  <img className="broker-card-logo" src={firstock} alt="" width="24" />
                  <div className="broker-card-text">
                    <span className="broker-card-name">Firstock</span>
                  </div>
                </div>
              </button>
            </a>
          </Col>
        </Row>
        <Row className="g-0 ps-3 mb-1 mt-3 justify-content-center">
        </Row>
        <BrokerLoginModal loginType={loginType} show={show} close={() => setShow(false)}></BrokerLoginModal>
      </div>
    );
  }

  return (
    <Section fluid className="py-0">
    <Row className="g-0 min-vh-100 flex-center ">
      <Col lg={4} xxl={5} className="py-3 position-relative">
        <img
          className="bg-auth-circle-shape"
          src={bgShape}
          alt=""
          width="250"
        />
        <img
          className="bg-auth-circle-shape-2"
          src={shape1}
          alt=""
          width="150"
        />
        <Card className="overflow-hidden fixed-width-page z-index-1">
          <Card.Body className="p-0">
            <Row className="fixed-height-page g-0">
              <Col
                md={12}
              >
               
                  <div>
                  <div className={classes.backButton}> 
                    <Link   to={{ pathname: '/broker-login' }} >
                      <FontAwesomeIcon icon={'arrow-left'} /> Back
                    </Link>
                  </div>
                    <div style={{marginBottom: "20px", marginTop: "15px"}} className="d-flex justify-content-center align-items-center d-block d-xs-none">
                        <img
                          className="text-center"
                          src={logo}
                          alt=""
                          width={40}
                          style={{marginRight:"5px"}}
                      />
                        <h5 className="text-center " style={{color:"#2c87f2", fontWeight: "800", fontSize: "26px"}}>FNOTrader</h5>
                    </div>
                    <div className={!isMobile ? "landing-page-header_":""} style={{textAlign:"center",color:"#4b5563", backgroundColor:"#fff",paddingTop:"15px",paddingBottom:"15px"}}>
                      <h4 className={classes.h5Bold} style={{color: "#4b5563"}}> Open a broker account of your choice. </h4>
                      <h3 className={classes.h5Bold}  style={{ fontWeight: "800",fontSize: "22px", color: "#4b5563"}}>Get 1 month free subscription. </h3>
                    </div>

                    <Row className="g-0 ps-3 mb-1 mt-5 justify-content-center">
                        <Col md={4} xs={6}  className="mb-3">
                          <a className='text-white' href="https://www.5paisa.com/demat-account?ReferralCode=57003172&ReturnUrl=invest-open-account" target="_blank" rel="noopener noreferrer">
                            <Button
                              variant="outline-secondary"
                              size="md"
                              className={classes.boxSize}
                            >
                              <img className="" src={paisa} alt="" width="30" />
                              <p>5Paisa</p>
                            </Button>
                          </a>
                        </Col>
                        <Col md={4} xs={6}  className="mb-3">
                          <a className='text-white' href="https://signup.firstock.in/?p=FNO99" target="_blank" rel="noopener noreferrer">
                            <Button
                              variant="outline-secondary"
                              size="md"
                              className={classes.boxSize}
                            >
                              <img className="" src={firstock} alt="" width="30" />
                              <p>Firstock</p>
                            </Button>
                          </a>
                        </Col>
                    </Row>
                  </div>
              </Col>
            </Row>
            <BrokerLoginModal loginType={loginType} show={show} close={() => setShow(false)}></BrokerLoginModal>
          </Card.Body>
        </Card>
      </Col>
    </Row>
    
  </Section>
      
  );
};

export default DontBrokerAccount;